<template>
  <div class="h-full w-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-full h-full overflow-hidden">
      <gallery-grid :multimedia="listGalleryMultimedia"></gallery-grid>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GalleryGrid from "./GalleryGrid";

// Nombre de días...
const weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
const month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

export default {
  name: "Gallery",
  data: function () {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      category: localStorage.getItem("category"),
      email: localStorage.getItem("email"),
      listGalleryMultimedia: []
    };
  },
  components: {
    GalleryGrid
  },
  mounted() {
    this.getLevantamientos();
  },
  methods: {
    getLevantamientos: function () {
      axios
        .post(
          "apidev/levantamientos/getAllLevantamientos",
          {
            category: this.category,
            email: this.email
          },
          this.config
        )
        .then(response => {
          let listaLevantamientos = response.data.levantamientos;

          if (this.category != "ADMINISTRADOR" && this.category != "REVISOR"){
            listaLevantamientos = listaLevantamientos.filter(
              (levantamiento) => !levantamiento.ocultar_ficha || (levantamiento.ocultar_ficha && levantamiento.email == this.email)
            );
          }

          listaLevantamientos.forEach(levantamiento => {
            if (levantamiento.media_array !== null) {
              let multimediaArray = JSON.parse(levantamiento.media_array);
              multimediaArray.forEach(multimedia => {
                //if (multimediaArray.length > 0) {
                multimedia.usuario_id = levantamiento.usuario_id
                multimedia.nombre = levantamiento.nombre;
                multimedia.nombre_usuario = levantamiento.nombre_usuario;
                multimedia.apellido_usuario = levantamiento.apellido_usuario;
                let TDate = new Date(levantamiento.fecha_levantamiento);
                TDate =
                  weekday[TDate.getDay()] +
                  " " +
                  TDate.getDate() +
                  " de " +
                  month[TDate.getMonth()] +
                  " de " +
                  TDate.getFullYear();
                multimedia.TDate = TDate;
                multimedia.id = levantamiento.id;
                multimedia.latitud = levantamiento.latitud;
                multimedia.longitud = levantamiento.longitud;
                this.listGalleryMultimedia.push(multimedia);
                //}
              });
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
